import {
  Activity,
  BarChart3,
  BookOpen,
  Bot,
  Boxes,
  Briefcase,
  Building2,
  CalendarDays,
  ClipboardList,
  Coins,
  HeartPulse,
  KeyRound,
  Contact as ContactIcon,
  Eye,
  FolderOpen,
  GraduationCap,
  HandHelping,
  HardHat,
  Home,
  Inbox,
  KanbanSquare,
  LayoutDashboard,
  ListOrdered,
  MapPin,
  MapPinned,
  Megaphone,
  MessageCircle,
  MessagesSquare,
  Radio,
  Settings as SettingsIcon,
  ShieldCheck,
  Smartphone,
  Sparkles,
  Sun,
  UserCog,
  Users,
  Wallet,
  Wrench,
  type LucideIcon,
  Upload,
} from 'lucide-react';

/**
 * LOS ICONOS QUE EL REGISTRO PUEDE NOMBRAR.
 *
 * El servidor manda un NOMBRE (`'MessagesSquare'`), no un componente. Este mapa
 * es la traducción, y es explícito a propósito: resolver por índice sobre el
 * paquete entero metería todo lucide en el bundle que descarga el navegador.
 *
 * ═══ POR QUÉ ESTO VIVE EN SU PROPIO ARCHIVO ═══
 *
 * Estaba dentro de `Sidebar.tsx`, y por eso el lint del panel estaba en rojo:
 * un archivo que exporta componentes Y funciones rompe el fast refresh de
 * Vite. Al editar el sidebar, React no puede recargar solo ese componente y
 * recarga la página entera, perdiendo el estado.
 *
 * Es un warning, no un error, y por eso es fácil dejarlo pasar. La razón para
 * no dejarlo: el lint del panel estaba configurado con `--max-warnings 0`, así
 * que ese warning tenía la build en rojo, y una build en rojo permanente
 * enseña a ignorar el rojo.
 */
const ICONOS: Record<string, LucideIcon> = {
  Activity,
  BarChart3,
  BookOpen,
  Bot,
  Boxes,
  Briefcase,
  Building2,
  CalendarDays,
  ClipboardList,
  Coins,
  HeartPulse,
  Contact: ContactIcon,
  Eye,
  FolderOpen,
  GraduationCap,
  HandHelping,
  HardHat,
  Home,
  Inbox,
  KanbanSquare,
  LayoutDashboard,
  ListOrdered,
  MapPin,
  MapPinned,
  Megaphone,
  MessageCircle,
  MessagesSquare,
  Radio,
  Settings: SettingsIcon,
  ShieldCheck,
  KeyRound,
  Smartphone,
  Sparkles,
  Sun,
  UserCog,
  Users,
  Wallet,
  Wrench,
  Upload,
};

/** Nombre visible de cada grupo del sidebar. */
export const NOMBRE_DE_GRUPO: Record<string, string> = {
  atencion: 'Atención',
  crecimiento: 'Crecimiento',
  operacion: 'Operación',
  configuracion: 'Ajustes',
};

/**
 * Icono de una entrada. Si el registro nombra uno que no está en el mapa, se
 * cae a uno genérico en vez de romper el render: un icono equivocado es un
 * detalle; un sidebar en blanco deja al usuario sin poder navegar.
 */
export function iconoDe(nombre: string): LucideIcon {
  return ICONOS[nombre] ?? LayoutDashboard;
}
